import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ListingStatusForm from '../../../components/forms/ListingStatusForm';
import { useCreateListingStatus } from '../../../hooks/useListingStatusApi';
import { useNavigate } from 'react-router-dom';
import { ListingStatusDTO } from '../../../services/apiClient';

const ListingStatusCreate: React.FC = () => {
  const navigate = useNavigate();
  const createMutation = useCreateListingStatus();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Listing Statuses', href: '/admin/listingstatuses' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: ListingStatusDTO) => {
    try {
      setIsSubmitting(true);
      await createMutation.mutateAsync(data);
      navigate('/admin/listingstatuses');
    } catch (error) {
      console.error('Error creating ListingStatus:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/listingstatuses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.ListingStatus.Edit'
    >
        <ListingStatusForm
          initialValues={{} as ListingStatusDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/listingstatuses')}
        />
    </AdminLayout>
  );
};

export default ListingStatusCreate;